import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-college-teacher",
  templateUrl: "./college-teacher.component.html",
  styleUrls: ["./college-teacher.component.scss"],
})
export class CollegeTeacherComponent implements OnInit {
  selectedLanguage = "";
  font = "";
  fetchinData = true;

  ContentData: any[] = [];
  all_teachers_info: any[] = [];
  paginated_teachers_info: any[] = [];

  length = 0;
  pageSize = 15;
  pageIndex = 0;
  totalPages: number[] = [];

  groupedTeachers: any[] = []; // Grouped teachers by department

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchCollegeTeacherInfo();
  }

  /**
   * ✅ Fetch Teacher Information
   */
  FetchCollegeTeacherInfo() {
    forkJoin([this.appService.getTeaherStaff()]).subscribe((response: any) => {
      this.ContentData = response[0].data || [];

      this.groupTeachersByDepartment(); // group department wise
      this.fetchinData = false;
    });
  }

  /**
   * ✅ Group teachers by department (only active teachers, SalarySheet = Teacher/College Teacher)
   */
  groupTeachersByDepartment() {
    const grouped: { [key: string]: any[] } = {};
    const filteredTeachers: any[] = [];

    for (const teacher of this.ContentData) {
      if (
        (teacher.SalarySheet === "Teacher" ||
          teacher.SalarySheet === "College Teacher") &&
        teacher.IsActive === true
      ) {
        filteredTeachers.push(teacher);

        const dept = teacher.Department || "Unknown";
        if (!grouped[dept]) {
          grouped[dept] = [];
        }
        grouped[dept].push(teacher);
      }
    }

    console.log(
      "✅ Filtered Teachers (Active & SalarySheet=Teacher/College Teacher):",
      filteredTeachers
    );
    console.log("✅ Grouped Teachers by Department:", grouped);

    // Convert object → array
    this.groupedTeachers = Object.keys(grouped)
      .sort()
      .map((dept) => ({
        department: dept,
        teachers: grouped[dept],
      }));
  }

  /**
   * ✅ Pagination Helpers (if needed)
   */
  onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.paginateData();
  }

  paginateData() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginated_teachers_info = this.all_teachers_info.slice(
      startIndex,
      endIndex
    );
  }

  generatePageNumbers() {
    const totalPageCount = Math.ceil(this.length / this.pageSize);
    this.totalPages = Array.from({ length: totalPageCount }, (_, i) => i + 1);
  }

  /**
   * ✅ Dynamic Font
   */
  GetFontName() {
    switch (this.selectedLanguage) {
      case "en":
        return "Congenial";
      case "bn":
        return "Kalpurush";
      case "ar":
        return "Jameel Noori Nastaleeq";
      default:
        return "Arial";
    }
  }

  /**
   * ✅ Border color generator for cards
   */
  getColor(index: number): string {
    const colors = ["#007bff", "#28a745", "#ffc107", "#17a2b8", "#6f42c1"];
    return colors[index % colors.length];
  }
}
